import { Pipe, PipeTransform } from '@angular/core';
import { AppService } from '@Services/app.service';
import { ESystem } from '@Shared/models/index.model';

@Pipe({
    name: 'systemColourCode',
    standalone: true
})
export class SystemColourCodePipe implements PipeTransform {
  transform(system: ESystem): string {
    return this.appS.systemMetadataMap.get(system)?.colourCode;
  }
  constructor(public appS: AppService) {}
}

@Pipe({
    name: 'systemLink',
    standalone: true
})
export class SystemLinkPipe implements PipeTransform {
  transform(system: ESystem, link: string): string {
    if (link.trim()[0] != '/') {
      // console.log('parent.systemLink', parent.systemLink);
      link =
        (this.appS.systemMetadataMap.get(system)?.appRoute.pub || '') +
        '/' +
        link.trim();
    }
    return link;
  }
  constructor(public appS: AppService) {}
}
